function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 13,
  fill: "#7F7F7F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20 8.42062C19.4851 8.66145 18.9311 8.82434 18.3502 8.89709C18.9433 8.52228 19.3985 7.92923 19.6134 7.22141C19.0584 7.56865 18.4434 7.82056 17.7894 7.95634C17.2655 7.36781 16.519 7 15.6923 7C14.1064 7 12.8201 8.35668 12.8201 10.0294C12.8201 10.2669 12.8456 10.498 12.8948 10.7199C10.5077 10.5936 8.39117 9.38757 6.97442 7.55419C6.72723 8.00152 6.58542 8.52228 6.58542 9.07738C6.58542 10.1282 7.09287 11.0558 7.86315 11.5989C7.39255 11.5833 6.94936 11.4471 6.56229 11.2196C6.56207 11.2325 6.56207 11.2454 6.56207 11.258C6.56207 12.7258 7.55256 13.9501 8.86628 14.2282C8.62551 14.2978 8.37125 14.3347 8.1097 14.3347C7.9242 14.3347 7.74448 14.3159 7.56926 14.2807C7.9347 15.4839 8.99523 16.3598 10.2524 16.3845C9.26919 17.1971 8.03088 17.6813 6.68481 17.6813C6.45347 17.6813 6.22427 17.667 6 17.6388C7.27045 18.4987 8.78059 19 10.4026 19C15.6857 19 18.5749 14.3839 18.5749 10.3803C18.5749 10.249 18.5721 10.1182 18.5665 9.98853C19.1282 9.56154 19.6151 9.02813 20 8.42062Z",
  fill: "black"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.32d176af.svg";
export { ForwardRef as ReactComponent };